import { enqueueSnackbar } from "notistack";
import { useEffect, useRef } from "react";
import { Job } from "src/context/api/data/api";
import { useGetJobsQuery } from "src/context/api";
import {useLazyGetWorkspaceQuery, WorkspaceList, workspaces} from "src/context/api/workspaces";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";



export default function useJobs() {
    const { data: {jobs} = {jobs: []}, isLoading, isFetching } = useGetJobsQuery(undefined, { pollingInterval: 60 * 1000 });
    const prevJobs = useRef<Job[] | null>(null);
    const dispatch = useDispatch();

    const jobActionSideEffects = {
        "google_auth:save-objects": (job: Job) => {
            if (window.location.pathname.includes(`/workspaces/${job.workspace_id}/setup`)) {
                fetch(process.env.CROSS_API_URL + "/csrf").then((response) => response.text()).then((csrf) => {
                    return fetch(`${process.env.CROSS_API_URL}/workspaces/${job.workspace_id}`, {
                        headers: {
                            "X-CSRFToken": csrf,
                        },
                    });
                }).then((response) => response.json()).then((data: WorkspaceList) => {
                        dispatch(workspaces.util.updateQueryData("getWorkspace", { id: job.workspace_id }, (draft) => {
                            draft.google_auth_objects = data.google_auth_objects;
                            draft.google_auth = data.google_auth;
                        }) as any);
                });
            }
        },
        "bq:export": () => {
            return;
        },
    };

    useEffect(() => {
        if (jobs) {
            jobs.forEach((job) => {
                const currentJob = prevJobs.current?.find((prevJob) => prevJob.id === job.id);
                const currentJobCompleted = currentJob && currentJob.status === "completed";
                const newJobCompleted = job.status === "completed";
                if (!currentJob || ((!currentJobCompleted) && newJobCompleted) || (currentJob.status !== job.status)) {
                    jobActionSideEffects[job.action]?.(job);
                }
            });
        }
        prevJobs.current = jobs;
    }, [jobs]);

    return { jobs, isLoading, isFetching };
}